import { useEnhancedBrandStore } from '../../stores/enhancedBrandStore'
import { SearchResultsPreview } from './SearchResultsPreview'
import { ParsedBrand } from '../../types/brand'

interface SearchBarProps {
  onRowClick?: (brand: ParsedBrand) => void
}

export function SearchBar({ onRowClick }: SearchBarProps) {
  const { filters, setSearchTerm, filteredBrands, allBrands, isLoading } = useEnhancedBrandStore()

  // Show skeleton during loading
  if (isLoading) {
    return (
      <div className="animate-pulse">
        <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded-2xl"></div>
      </div>
    )
  }

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
        <svg className="w-5 h-5 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <input
        type="text"
        value={filters.searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search brands, products, or descriptions..."
        className="w-full pl-12 pr-4 py-3 text-base bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-2xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400"
      />
      {filters.searchTerm && (
        <div className="absolute inset-y-0 right-0 flex items-center pr-4">
          <button
            onClick={() => setSearchTerm('')}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}
      {filters.searchTerm && (
        <div className="absolute top-full left-0 right-0 mt-2 text-sm text-gray-600 dark:text-gray-400">
          <span className="font-medium text-blue-600 dark:text-blue-400">
            {filteredBrands.length.toLocaleString()}
          </span> of {allBrands.length.toLocaleString()} brands found
        </div>
      )}
      
      {/* Search Results Preview */}
      <SearchResultsPreview onRowClick={onRowClick} />
    </div>
  )
}